import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "hooks-for-redux";
import Search from "./Search";
import "../polyFill";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable";
import "@ungap/weakset";
import "@babel/polyfill";

ReactDOM.render(
  <React.StrictMode>
    <Provider>
      <Search />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
